<template>
  <section class="services" id="services">
    <div class="container">
      <div class="section-title">
        <h2>学校服务保障</h2>
        <p>从建设到运营，全周期护航学校智慧化升级</p>
      </div>
      <div class="service-list">
        <div class="service-item" v-for="service in services" :key="service.id">
          <div class="service-icon">
            <slot :name="'icon-' + service.id"></slot>
          </div>
          <h4>{{ service.title }}</h4>
          <p v-html="service.desc"></p>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
export default {
  name: 'ServiceSupport',
  data() {
    return {
      services: [
        { id: 1, title: '专属方案定制', desc: '结合学校需求，<br>量身定制最佳方案' },
        { id: 2, title: '部署实施保障', desc: '专业团队交付，<br>快速上线稳定可靠' },
        { id: 3, title: '7x24小时运维', desc: '全天候运维响应，<br>保障系统稳定运行' },
        { id: 4, title: '数据安全合规', desc: '多种安全防护，<br>守护校园数据安全' },
        { id: 5, title: '持续迭代升级', desc: '产品持续优化，<br>紧跟教育发展需求' }
      ]
    }
  }
}
</script>

<style scoped>
.services {
  padding: 80px 0;
  background: #f2f9fc;
}

.section-title {
  text-align: center;
  margin-bottom: 60px;
}

.section-title h2 {
  font-size: 36px;
  color: #1a1a1a;
  margin-bottom: 12px;
  font-weight: 700;
  letter-spacing: -0.5px;
}

.section-title p {
  font-size: 16px;
  color: #666;
  max-width: 600px;
  margin: 0 auto;
  line-height: 1.6;
}

.service-list {
  display: flex;
  justify-content: space-between;
  gap: 40px;
  max-width: 1200px;
  margin: 0 auto;
  /* padding: 0 40px; */
}

.service-item {
  flex: 1;
  text-align: center;
  padding: 40px 20px;
}

.service-icon {
  width: 80px;
  height: 80px;
  margin: 0 auto 24px;
  /* border: 2px dashed #409eff; */
  border-radius: 8px;
  display: flex;
  align-items: center;
  justify-content: center;
  /* background: #fff; */
  /* position: relative; */
}

.service-item h4 {
  font-size: 18px;
  margin-bottom: 12px;
  color: #1a1a1a;
  font-weight: 600;
}

.service-item p {
  font-size: 14px;
  color: #606266;
  line-height: 1.8;
  margin: 0;
}

.container {
  max-width: 1600px;
  margin: 0 auto;
  /* padding: 0 40px; */
}

/* 响应式设计 */
@media (max-width: 1024px) {
  .service-list {
    flex-wrap: wrap;
    gap: 30px;
  }
  
  .service-item {
    flex: 0 0 calc(50% - 15px);
  }
}

@media (max-width: 768px) {
  .service-list {
    flex-direction: column;
    gap: 20px;
    padding: 0 20px;
  }
  
  .service-item {
    flex: 1;
    padding: 30px 20px;
  }
  
  .section-title h2 {
    font-size: 28px;
  }
  
  .section-title p {
    font-size: 14px;
  }
}
</style>